var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column site_wrapper notfound"},[_c('img',{attrs:{"src":require("@/assets/images/Inactive_Linckard.svg")}}),_vm._v(" "),_c('label',{staticClass:"notff"},[_vm._v(_vm._s(_vm.leyenda))])])
}
var staticRenderFns = []

export { render, staticRenderFns }